import { useContext } from 'react';
import { ToastContextDesktop } from '@teko/ds-foundation';

const useToast = () => {
  return useContext(ToastContextDesktop);
};

export { useToast };
